import { render } from "./GameOfLife.vue?vue&type=template&id=6ff966a0&scoped=true"
import script from "./GameOfLife.vue?vue&type=script&lang=js"
export * from "./GameOfLife.vue?vue&type=script&lang=js"

import "./GameOfLife.vue?vue&type=style&index=0&id=6ff966a0&scoped=true&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ff966a0"]])

export default __exports__